import React from 'react';

import { AccountDisplayProps } from '../AccountPanel';
import { Serving } from './Serving';

export const SettingServing: React.FC<AccountDisplayProps> = ({
	popDisplayState,
}) => {
	return <Serving onSave={popDisplayState} />;
};
